import { ChangeDetectorRef, Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { ToastrService } from "ngx-toastr";
import { Globals } from "../../common/global";
import { ConfigApi } from "../../config-api";
import { ApiCallingService } from "../../services/api-calling.service";

@Component({
  selector: "app-vending-category",
  templateUrl: "./vending-category.component.html",
  styleUrls: ["./vending-category.component.css"],
})
export class VendingCategoryComponent implements OnInit {
  categoryData: any[] = [];
  page: number = 1;
  pageSize: number = 10;
  totalCount: number = 0;
  loading: boolean = false;
  userDetails: any;
  modeltitle: any;
  detail: any = {};
  categoryToDelete: string = "";

  constructor(
    private router: Router,
    private apiCallingService: ApiCallingService,
    private toastr: ToastrService,
    public globals: Globals,
    private modalService: NgbModal,
    private cdr: ChangeDetectorRef
  ) {
    let data = localStorage.getItem("Auth-user");
    if (!data) {
      return;
    }
    try {
      this.userDetails = JSON.parse(data);
    } catch (error) {
      console.error(error);
    }
  }

  ngOnInit(): void {
    this.getCategoryList();
  }

  getCategoryList() {
    this.loading = true;
    this.apiCallingService
      .callAPI(
        {},
        "GET",
        ConfigApi.URLS.VENDING_CATEGORY.LIST +
          `?operator_id=${this.userDetails._id}&page=${this.page - 1}&limit=${
            this.pageSize
          }`
      )
      .subscribe(
        (res) => {
          if (this.apiCallingService.handleSuccess(res)) {
            this.categoryData = res.data || [];
            this.totalCount = res.total || 0;
          }
          this.loading = false;
        },
        (error) => {
          console.error(error);
          this.toastr.error("Failed to load categories");
          this.loading = false;
        }
      );
  }

  openModal(targetModal: any, data: any, title: any) {
    this.modalService.open(targetModal, {
      centered: true,
      backdrop: "static",
      size: "sm",
    });
    this.modeltitle = title;
    this.detail = Object.assign({}, data);
  }

  downloadSampleCSV() {
    const link = document.createElement("a");
    link.href = "assets/SampleVendingCategoryCSV.csv";
    link.download = "sample-vending-category.csv";
    link.click();
  }

  uploadCategoryCSV(event: any) {
    const fileInput = event.target as HTMLInputElement;
    const file = fileInput.files?.[0];

    if (file) {
      const formData = new FormData();
      formData.append("csv_file", file);
      formData.append("operator_id", this.userDetails._id);

      this.apiCallingService
        .callAPI(
          formData,
          "POST",
          ConfigApi.URLS.VENDING_CATEGORY.UPLOAD_CATEGORY_CSV
        )
        .subscribe(
          (res) => {
            if (this.apiCallingService.handleSuccess(res)) {
              this.toastr.success(
                res.msg || "Category CSV uploaded successfully"
              );
              this.ngOnInit();
            } else {
              this.toastr.error(res.msg || "Error uploading CSV");
              this.ngOnInit();
            }
            fileInput.value = "";
          },
          (err) => {
            this.toastr.error(err.error?.msg || "Error uploading CSV", "Error");
            fileInput.value = "";
            this.ngOnInit();
          }
        );
    }
  }

  onSubmit() {
    if (this.detail._id) {
      this.updateCategory();
    } else {
      this.addCategory();
    }
  }

  addCategory() {
    const payload = {
      category_name: this.detail.category_name,
      sortCount: this.detail.sortCount,
      operator_id: this.userDetails._id,
    };

    this.apiCallingService
      .callAPI(payload, "POST", ConfigApi.URLS.VENDING_CATEGORY.CREATE)
      .subscribe(
        (res) => {
          if (this.apiCallingService.handleSuccess(res)) {
            this.toastr.success(res.msg || "Category added successfully");
            this.closeBtnClick();
            this.getCategoryList();
          }
        },
        (error) => {
          console.error(error);
          this.toastr.error("Failed to add category");
        }
      );
  }

  updateCategory() {
    const payload = {
      category_name: this.detail.category_name,
      operator_id: this.userDetails._id,
      sortCount: this.detail.sortCount,
    };

    this.apiCallingService
      .callAPI(
        payload,
        "PUT",
        ConfigApi.URLS.VENDING_CATEGORY.UPDATE + `/${this.detail._id}`
      )
      .subscribe(
        (res) => {
          if (this.apiCallingService.handleSuccess(res)) {
            this.toastr.success(res.msg || "Category updated successfully");
            this.closeBtnClick();
            this.getCategoryList();
          }
        },
        (error) => {
          console.error(error);
          this.toastr.error("Failed to update category");
        }
      );
  }

  openDeleteModal(deleteModal: any, categoryId: string) {
    this.categoryToDelete = categoryId;
    this.modalService.open(deleteModal, {
      centered: true,
      backdrop: "static",
      size: "sm",
    });
  }

  confirmDelete() {
    if (!this.categoryToDelete) {
      return;
    }

    this.apiCallingService
      .callAPI(
        {},
        "DELETE",
        ConfigApi.URLS.VENDING_CATEGORY.DELETE + `/${this.categoryToDelete}`
      )
      .subscribe(
        (res) => {
          if (this.apiCallingService.handleSuccess(res)) {
            this.toastr.success(res.msg || "Category deleted successfully");
            this.closeDeleteModalClick();
            this.getCategoryList();
          }
        },
        (error) => {
          console.error(error);
          this.toastr.error("Failed to delete category");
        }
      );
  }

  loadPage(page: number) {
    this.page = page;
    this.getCategoryList();
  }

  closeBtnClick() {
    this.modalService.dismissAll();
    this.detail = {};
  }

  closeDeleteModalClick() {
    this.modalService.dismissAll();
    this.categoryToDelete = "";
  }

  handleProductList(category: any) {
    this.router.navigate([`/user/vending-category/products/${category._id}`]);
  }
}
